document.addEventListener('DOMContentLoaded', function () {
  const toggleElements = document.querySelectorAll('[data-toggle-popup]');

  function randString() {
    return `async-load-${Math.random().toString(36).substring(2, 14).padEnd(12, '0')}`;
  }

  /**
   * @param {String} string
   * @return {String}
   */
  function toPascalCase(string) {
    return string
      .toLowerCase()
      .replace(/(^\w|-\w)/g, (match) =>
        match.replace(/-/, '').toUpperCase()
      );
  }

  /**
   * @param {String} name
   * @param {String} templateId
   * @param {Boolean} isPopup
   * @return Promise<void>
   */
  function loadExtension(name, templateId, isPopup = false) {
    return new Promise(function (resolve, reject) {
      if (!name) {
        return reject();
      }
      const isForm = !name.includes('.');
      let componentName = name;
      if (!isForm) {
        const parts = name.split('.');
        componentName = parts[parts.length - 1];
      }
      if (isPopup) {
        const element = document.createElement('div');
        element.id = templateId;
        document.body.appendChild(element);
      }
      if (isForm) {
        BX.Runtime.loadExtension(`citrus.app.presentation.feedback`)
          .then(() => {
            /** @type {VoidFunction} */
            const mountFunc = BX.Citrus.Components[toPascalCase(componentName)];
            !!mountFunc && mountFunc({ templateId });
            resolve();
          })
          .catch(reject);
      } else {
        BX.Runtime.loadExtension(name)
          .then(() => {
            /** @type {VoidFunction} */
            const mountFunc = BX.Citrus.Components[componentName];
            !!mountFunc && mountFunc({ templateId });
            resolve();
          })
          .catch(reject);
      }
    });
  }

  toggleElements.forEach((element) => {
    element.classList.remove('b-btn_loading');

    element.addEventListener('click', function (event) {
      event.preventDefault();
      /** @type {{ togglePopup: String }} */
      const dataset = element.dataset;
      if (!!element.id) {
        const name = dataset.togglePopup;
        const isForm = !name.includes('.');
        let componentName = name;
        if (!isForm) {
          const parts = name.split('.');
          componentName = parts[parts.length - 1];
        }
        BX.onCustomEvent(`${toPascalCase(componentName)}:open`);
        return;
      }
      const templateId = randString();
      element.id = `${templateId}-toggle`;
      element.classList.add('b-btn_loading');
      element.disabled = true;
      loadExtension(dataset.togglePopup, templateId, true)
        .then(function () {
          element.classList.remove('b-btn_loading');
          element.disabled = false;
        })
        .catch(function () {
          element.classList.remove('b-btn_loading');
          element.disabled = false;
        });
    });
  });
});